import { api } from '@/lib/api';
import type { IApiResponse, IScheduledJob, IScheduledJobUpdate } from '@skystone/shared';

export const scheduledJobApi = {
  getAll: async (): Promise<IScheduledJob[]> => {
    const result = await api.get<IApiResponse<IScheduledJob[]>>('/scheduled-jobs');
    return result.data;
  },

  getById: async (id: string): Promise<IScheduledJob> => {
    const result = await api.get<IApiResponse<IScheduledJob>>(`/scheduled-jobs/${id}`);
    return result.data;
  },

  update: async (id: string, data: IScheduledJobUpdate): Promise<IScheduledJob> => {
    const result = await api.put<IApiResponse<IScheduledJob>>(`/scheduled-jobs/${id}`, data);
    return result.data;
  },

  delete: (id: string) => api.delete<void>(`/scheduled-jobs/${id}`),

  enable: async (id: string): Promise<IScheduledJob> => {
    const result = await api.post<IApiResponse<IScheduledJob>>(`/scheduled-jobs/${id}/enable`);
    return result.data;
  },

  disable: async (id: string): Promise<IScheduledJob> => {
    const result = await api.post<IApiResponse<IScheduledJob>>(`/scheduled-jobs/${id}/disable`);
    return result.data;
  },

  trigger: async (id: string): Promise<{ message: string }> => {
    const result = await api.post<IApiResponse<{ message: string }>>(`/scheduled-jobs/${id}/trigger`);
    return result.data;
  },
};
